import { GlobalConfigRouteMetaEnum } from 'kuaidong-model'
import VueRouter, { RouteConfig } from 'vue-router'

const GymnasticsList = () => import('@/views/broadcast-gymnastics/GymnasticsList.vue')
const GymnasticsEditA = () => import('@/views/broadcast-gymnastics/GymnasticsEditA.vue')
const GymnasticsEditB = () => import('@/views/broadcast-gymnastics/GymnasticsEditB.vue')
const GymnasticsRulePage = () => import('@/views/broadcast-gymnastics/GymnasticsRulePage.vue')
const GymnasticsDetailPage = () => import('@/views/broadcast-gymnastics/GymnasticsDetailPage.vue')
const SelectGymnasticsPage = () => import('@/views/broadcast-gymnastics/SelectGymnasticsPage.vue')
const SelectSplitPage = () => import('@/views/broadcast-gymnastics/SplitSelectPage.vue')
const GymnasticsAbout = () => import('@/views/broadcast-gymnastics/GymnasticsAbout.vue')
const GymnasticsMinePage = () => import('@/views/move-practice/Mine.vue')
const GymnasticsMineDetailPage = () => import('@/views/move-practice/VideoDetail.vue')
const GymnasticsMineCreatePage = () => import('@/views/move-practice/Edit.vue')

const listRoute: RouteConfig = {
  path: '/gymnastics-list-page',
  name: 'gymnastics_list_page',
  component: GymnasticsList,
  props: (route) => ({ listType: +route.query.t || 0 }),
  meta: {
    title: '广播体操列表',
  },
}

const aboutRoute: RouteConfig = {
  path: '/gymnastics-about-page',
  name: 'gymnastics_about_page',
  component: GymnasticsAbout,
  meta: {
    title: '功能描述',
  },
}

const detailRoute: RouteConfig = {
  path: '/gymnastics-detail-page',
  name: 'gymnastics_detail_page',
  component: GymnasticsDetailPage,
  meta: {
    title: '练习详情页',
  },
  props: (route: any) => ({ ...route.query, ...route.params }),
}

const editBRoute: RouteConfig = {
  path: '/gymnastics-edit-b',
  name: 'gymnastics_edit_b',
  component: GymnasticsEditB,
  meta: {
    title: '编辑列表',
    stepTitle: '练习内容',
    nextStep: detailRoute.name,
    nextButtonText: '完成',
  },
  props: (route) => ({
    ...route.query,
    ...route.params,
    currentStep: Number(route.query.currentStep),
    totalSteps: Number(route.query.totalSteps),
  }),
}

const editARoute: RouteConfig = {
  path: '/gymnastics-edit-a',
  name: 'gymnastics_edit_a',
  component: GymnasticsEditA,
  meta: {
    title: '编辑列表',
    stepTitle: '基础信息',
    nextStep: editBRoute.name,
  },
  props: (route) => ({
    ...route.query,
    ...route.params,
    currentStep: Number(route.query.currentStep) || 1,
    totalSteps: Number(route.query.totalSteps) || 2,
    activityId: route.query.activityId || 'activity_202109_move',
    mode: route.query.mode || 'add',
  }),
}

const selectGymnasticsRoute: RouteConfig = {
  path: '/select-gymnastics',
  name: 'select_gymnastics',
  component: SelectGymnasticsPage,
  meta: {
    title: '选择广播体操',
    [GlobalConfigRouteMetaEnum.All]: true,
  },
}
const selectSplitRoute: RouteConfig = {
  path: '/select-splits',
  name: 'select_splits',
  component: SelectSplitPage,
  props: (route: any) => ({ ...route.query, ...route.params }),
}
const gymnasticsRuleRoute: RouteConfig = {
  path: '/gymnastics-rule',
  name: 'gymnastics_rule',
  component: GymnasticsRulePage,
  meta: {
    title: '广播体操规则',
  },
  props: (route: any) => ({ ...route.query, ...route.params }),
}

const gymnasticsMineRoute: RouteConfig = {
  path: '/gymnastics-mine',
  name: 'gymnastics_mine',
  component: GymnasticsMinePage,
  meta: {
    title: '我的自编操',
  },
}

const gymnasticsMineDetailRoute: RouteConfig = {
  path: '/gymnastics-mine-detail',
  name: 'gymnastics_mine_detail',
  component: GymnasticsMineDetailPage,
  props: (route: any) => ({ ...route.query, ...route.params }),
  meta: {
    title: '我的自编操',
  },
}
const gymnasticsMineCreateRoute: RouteConfig = {
  path: '/gymnastics-mine-create',
  name: 'gymnastics_mine_create',
  component: GymnasticsMineCreatePage,
  props: (route: any) => ({ ...route.query, ...route.params }),
  meta: {
    title: '我的自编操',
  },
}

export default [
  listRoute,
  aboutRoute,
  editARoute,
  editBRoute,
  detailRoute,
  selectGymnasticsRoute,
  selectSplitRoute,
  gymnasticsRuleRoute,
  gymnasticsMineRoute,
  gymnasticsMineDetailRoute,
  gymnasticsMineCreateRoute,
]

export function navigateToGymnasticsList(router: VueRouter) {
  router.push({ name: listRoute.name })
}

export function navigateToGymnasticsAbout(router: VueRouter) {
  router.push({ name: aboutRoute.name })
}

export function navigateToGymnasticsEditA(router: VueRouter, mode = 'add') {
  router.push({ name: editARoute.name, query: { currentStep: '1', totalSteps: '2', mode: mode } })
}

export function navigateToGymnasticsEditB(router: VueRouter) {
  router.push({ name: editBRoute.name, query: { currentStep: '2', totalSteps: '2' } })
}

export function navigateToGymnasticsSelect(router: VueRouter) {
  router.push({ name: selectGymnasticsRoute.name })
}

export function navigateToGymnasticsSelectSplit(router: VueRouter, weekSeq: string) {
  router.push({
    path: selectSplitRoute.path,
    query: {
      weekSeq: String(weekSeq),
    },
  })
}

export function navigateToGymnasticsRuleRoute(router: VueRouter, drill_id?: string) {
  router.push({
    name: gymnasticsRuleRoute.name,
    query: {
      drill_id,
    },
  })
}

export function navigateToGymnasticsDetailRoute(router: VueRouter, move_uuid: string) {
  router.push({
    name: detailRoute.name,
    query: {
      move_uuid,
    },
  })
}
